import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const ProfileIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="profile-icon"
      viewBox="0 0 22 22"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M7 8a4 4 0 108 0 4 4 0 00-8 0zm2 0a2 2 0 104 0 2 2 0 00-4 0z"
        clipRule="evenodd"
      />
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm9 11c0 2.09-.712 4.014-1.908 5.542A8.986 8.986 0 0010.936 13a8.984 8.984 0 00-7.092 3.458A9 9 0 1120 11zm-9 9c2.15 0 4.124-.754 5.672-2.012A6.992 6.992 0 0010.935 15a6.991 6.991 0 00-5.689 2.92A8.964 8.964 0 0011 20z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default ProfileIcon;
